<script>
export default {
    name: "ItemIssueHistory",

    props: {
        showModal: Boolean,
        invoice: {
            type: Object,
            required: true,
        },
        itemdetails: {
            type: Array,
            required: true,
        },
        itemIssueHistory: {
            type: Array,
            required: true,
        },
    },
}
</script>
<template>
<tail-modal :show="showModal" dimension="md:w-2/3 w-11/12">
  <template v-slot:title>
    <h5 class="font-medium text-sm">Departmental Item Details</h5>
  </template>
  <template v-slot:modal-body>
    <div class="w-full flex flex-wrap items-center">
        <div class="w-full p-1">
            <h5 class="text-sm font-medium">ITEM CHARGES AND PAYMENTS FOR: {{ invoice.groupName.toUpperCase() }}</h5>
        </div>
        <div class="w-full overflow-auto">
            <table class="table text-xs">
                <thead class="bg-blue-500 text-white">
                    <tr>
                        <th class="p-tiny">Date</th>
                        <th class="p-tiny">MRNo</th>
                        <th class="p-tiny">Patient</th>
                        <th class="p-tiny">Op File No</th>
                        <th class="p-tiny">Type</th>
                        <th class="p-tiny">Item</th>
                        <th class="p-tiny"> Charges</th>  
                        <th class="p-tiny"> Cash Payments</th> 
                         <th class="p-tiny">Isurance Amount</th>
                         <th class="p-tiny">Waiver Amount</th>
                    </tr>
                </thead>
                <tbody class="bg-gray-100">
                    <tr v-for="(itemdetail, idx) in itemdetails" :key="idx">
                        <td class="p-tiny">{{ itemdetail.date | dateFormat }}</td>
                        <!-- <td class="p-tiny">
                            <h5>Names: {{ itemIssue.names }}</h5>
                            <h5>MRN: {{ itemIssue.patientID}}</h5>
                            <h5>Type: 
                                {{ 
                                    itemIssue.iS_IN_PATIENT == 'True' ? `Inpatient` : `Outpatient`
                                }}
                            </h5>
                        </td> -->
                        <td class="p-tiny">{{ itemdetail.patientID }}</td>
                        <td class="p-tiny">{{ itemdetail.names }}</td>
                        <td class="p-tiny">{{ itemdetail.opfileno }}</td>
                        <td class="p-tiny">{{ itemdetail.typeName }}</td>
                        <td class="p-tiny">{{ itemdetail.itemName }}</td>
                        <td class="p-tiny">{{ itemdetail.totalCharges|numberFormat  }}</td>
                        <td class="p-tiny">{{ itemdetail.cashPayments|numberFormat  }}</td>
                        <td class="p-tiny">{{ itemdetail.insuranceAmount|numberFormat }}</td>
                        <td class="p-tiny">{{ itemdetail.waiveredAmount|numberFormat  }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
  </template>
  <template v-slot:modal-footer>
    <button 
        class="btn-danger btn-sm text-xs rounded" 
        @click.prevent="$emit(`closeModal`)"><i class="fa fa-times"></i> Close</button>
  </template>
</tail-modal>
</template>